import { Component } from '@angular/core';

@Component({
  selector: 'app-e-library',
  templateUrl: './e-library.component.html',
  styleUrls: ['./e-library.component.scss']
})
export class ELibraryComponent {

}
